"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractDateFromString = extractDateFromString;
exports.getEmiratesIdData = getEmiratesIdData;
exports.getObjectFromArray = void 0;
exports.isEmiratesExpiryDate = isEmiratesExpiryDate;
exports.isEmiratesIdValid = isEmiratesIdValid;
exports.isPassportValid = isPassportValid;
function isEmiratesIdValid(emirateId) {
  const regex = /^[0-9]{3}-[0-9]{4}-[0-9]{7}-[0-9]{1}$/;
  return regex.test(emirateId);
}
function isEmiratesExpiryDate(date) {
  const regex = /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/;
  return regex.test(date.replace("'", ''));
}
function extractDateFromString(str) {
  return str.replace(/[^a-zA-Z^0-9/]/g, '');
}
function isPassportValid(passportValue) {
  const regex = [/^[A-Z]{3}[0-9]{6}$/, /^[A-Z]{4}[0-9]{5}$/, /^[A-Z]{1}[0-9]{7}$/, /^[0-9]{9}$/, /^[A-Z]{1}[0-9]{8}$/];
  return regex.some(rx => rx.test(passportValue));
  // if (!regex.test(passportValue)) {
  //   return false;
  // }
  // if (passportValue.length >= 3 && passportValue.length <= 9) {
  //   return true;
  // }
  // return false;
}

/**
 * @param regions array
 * @returns
 */
function getEmiratesIdData(regions) {
  let wholeText = '';
  let emiratesId = '';
  let emairateExpiryDate = '';
  let dob = '';
  let name = '';
  if (regions) {
    regions.forEach(item => {
      wholeText = wholeText + '\n';
      const lines = item.lines;
      if (lines) {
        wholeText = wholeText + '\n';
        lines.forEach(item1 => {
          const words = item1.words;
          wholeText = wholeText + '\n';
          if (words) {
            let isNameIncludes = false;
            words.forEach(item2 => {
              const text = item2.text;
              if (isNameIncludes) {
                name = name + ' ' + text;
              }
              if (isEmiratesIdValid(text)) {
                emiratesId = text;
              }
              if (isPassportValid(text)) {
                emiratesId = text;
              }
              if (isEmiratesExpiryDate(text)) {
                if (dob === '') {
                  dob = extractDateFromString(text);
                } else {
                  emairateExpiryDate = extractDateFromString(text);
                }
              }
              wholeText = wholeText + text;
              if (text.toLowerCase().includes('name')) {
                isNameIncludes = true;
              }
            });
          }
        });
      }
    });
  }
  return {
    allData: wholeText,
    emiratesId: emiratesId,
    dob: dob,
    emairateExpiryDate: emairateExpiryDate,
    name: name
  };
}
const getObjectFromArray = (array, filter) => {
  var _updatedArray$;
  const updatedArray = array.filter(item => item.url === filter) || [];
  return (_updatedArray$ = updatedArray[0]) !== null && _updatedArray$ !== void 0 ? _updatedArray$ : {};
};
exports.getObjectFromArray = getObjectFromArray;